import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface StyledTitleProps {
  color?: string;
  children: ReactNode;
  className?: string;
}

export function StyledTitle({ children, className = "" }: StyledTitleProps) {
  return (
    <h2
      className={cn(
        "mt-0 mb-4 text-center font-serif text-4xl leading-tight font-light text-gray-800 sm:text-4xl md:text-5xl",
        className,
      )}
    >
      {children}
    </h2>
  );
}

interface StyledSubtitleProps {
  children: ReactNode;
  className?: string;
}

export function StyledSubtitle({
  children,
  className = "",
  ...props
}: StyledSubtitleProps) {
  return (
    <div
      className={cn(
        `mx-auto max-w-4xl pb-2 text-center text-lg text-gray-600 sm:text-2xl`,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

interface StyledSmallTextProps {
  color?: string;
  children: ReactNode;
  className?: string;
}

export function StyledSmallText({
  children,
  className = "",
  ...props
}: StyledSmallTextProps) {
  return (
    <div
      className={cn(
        `mb-3 text-center text-sm font-medium tracking-wider text-blue-700`,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
